import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "tm_tools_token";

export const getToolsToken = () => localStorage.getItem(TOKEN_KEY);
export const setToolsToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToolsToken = () => localStorage.removeItem(TOKEN_KEY);

export const toolsApi = axios.create({ baseURL: API });

toolsApi.interceptors.request.use((config) => {
  const token = getToolsToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Stripe Checkout cannot be displayed inside an iframe (e.g. the Emergent preview),
// so navigate the top-most window to escape any embedding; fall back to a new tab,
// then to the current window (deployed site, where there is no iframe).
export function goToCheckout(url) {
  try {
    if (window.self !== window.top) {
      window.top.location.href = url;
      return;
    }
  } catch (e) {
    const w = window.open(url, "_blank");
    if (w) return;
  }
  window.location.href = url;
}
